import Vue from 'vue'
import types from '../mutations/mutation-types'

export default {
  [types.NUDGE.ADD_MESSAGE] (state, messageDetails) {
    state.messages[messageDetails.language] = messageDetails.text
  },
  [types.NUDGE.REMOVE_MESSAGE] (state, key) {
    Vue.delete(state.messages, key)
  },
  [types.NUDGE.QUERY_RESULT] (state, queryCount) {
    state.responseMessage = {}
    state.queryCount = queryCount
  },
  [types.NUDGE.RESULT_MESSAGE] (state, message) {
    state.queryCount = ''
    state.responseMessage = message
  },
  [types.NUDGE.LOAD_NUDGES] (state, nudges) {
    state.allNudges = nudges
  },
  [types.NUDGE.LOAD_A_NUDGE_STATS] (state, stats) {
    state.aNudge = stats
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/nudge.js